<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasEmployee="true"
      :hasDirectory="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    ></condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      columns: [
        { name: "DirectoryName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Barcode" },
        { name: "Qty" },
        { name: "Cost" },
      ],
      items: [],
      pagination: {},
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getStockAdjustDirectory(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getStockAdjustDirectory(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printStockAdjustDirectory(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getStockAdjustDirectory(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
